<template>
  <div class="app-input-container" :class="{ inline, focused, error, warning }">
    <slot v-if="ignoreLabel" />

    <label v-else>
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: 'AppInputContainer',

  data() {
    return { focused: false }
  },

  props: {
    error: {
      type: Boolean,
      default: false,
    },

    warning: {
      type: Boolean,
      default: false,
    },

    ignoreLabel: {
      type: Boolean,
      default: false,
    },

    inline: {
      type: Boolean,
      default: false,
    },

    required: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import '@/styles/settings.scss';

.app-input-container {
  margin-top: math.div($defaultPadding, 1.25);

  &:first-of-type {
    margin-top: 0;
  }

  &,
  > label {
    display: flex;
    flex-direction: column;
  }

  > label {
    width: 100%;
  }

  &.focused {
    :deep(.app-input-label) {
      color: $primaryColor;
    }

    :deep(.app-input-clear-button) {
      > .app-button {
        background-color: $primaryColor;
        color: #fff;
      }
    }
  }

  &.error {
    color: $errorColor;

    :deep(.app-input),
    :deep(.app-input-help-text),
    &.focused :deep(.app-input-label) {
      color: inherit;
    }

    :deep(.app-input-clear-button) {
      > .app-button {
        background-color: $errorColor;
        color: #fff;
      }
    }

    :deep(.app-input) {
      background-color: rgba($errorColor, 0.1);
    }
  }

  &.warning {
    color: $warningColor;

    :deep(.app-input),
    :deep(.app-input-help-text),
    &.focused :deep(.app-input-label) {
      color: inherit;
    }

    :deep(.app-input-clear-button) {
      > .app-button {
        background-color: $warningColor;
        color: #fff;
      }
    }

    :deep(.app-input) {
      background-color: rgba($warningColor, 0.1);
    }
  }

  &.inline {
    &,
    > label {
      flex-direction: row;
      align-items: center;
    }

    :deep(.app-input-label) {
      margin-right: 1rem;
    }

    :deep(.app-input) {
      flex: 1;
    }
  }
}
</style>
